// 采购模块接口
import services from "@/utils/request";

//解析
export function search(data, params) {
  return services({
    method: "POST",
    url: "/purchase/order/sales/search",
    data: data,
    params: params,
  });
}

// 创建普通订单
export function normal(data, params) {
  return services({
    method: "POST",
    url: "/purchase/order/async/create",
    data: data,
  });
}

// 查看采购订单
export function purSearch(params, data) {
  return services({
    method: "POST",
    url: "/purchase/order/search",
    data: data,
    params: params,
  });
}

// 获取用户配置采购列表

export function purchaseUserConfig(params, data) {
  return services({
    method: "GET",
    url: "/purchase/purchaseUserConfig",

    params: params,
  });
}
// 设置配置信息
export function setting(data) {
  return services({
    method: "PUT",
    url: "/purchase/purchaseUserConfig/setting",

    data: data,
  });
}
// 获取当前的配置信息以及数量
export function statistics(params) {
  return services({
    method: "POST",
    url: "/purchase/order/statistics",
    data: params,
  });
}

// 下单前的效验
export function checkBeforePurchase(params) {
  return services({
    method: "POST",
    url: "/purchase/order/async/checkBeforePurchase",
    data: params,
  });
}

// 解析的数据2
export function JieXiParse(params) {
  return services({
    method: "POST",
    url: "/purchase/product/parse",
    data: params,
  });
}
// 获取销售商品与采购商品关系

export function PurchaseRelation(params) {
  return services({
    method: "POST",
    url: "/goods/getSalesGoodsWithPurchaseRelation",
    data: params,
  });
}
// 绑定销售商品和采购商品关系
export function bind(params) {
  return services({
    method: "POST",
    url: "/goods/purchase/bind",
    data: params,
  });
}
// /删除销售商品和采购商品关系
export function DelPurchase(params) {
  return services({
    method: "DELETE",
    url: `/goods/purchase/${params.tableId}`,
  });
}

// 销售商品sku和采购商品sku绑定

export function updateSalesGoodsPurchaseRelations(params) {
  return services({
    method: "POST",
    url: "/goods/updateSalesGoodsPurchaseRelations",
    data: params,
  });
}

// 获取销售商品以及sku信息
export function info(params) {
  return services({
    method: "GET",
    url: "/goods/sales/info",
    params: params,
  });
}
// 获取采购商品与销售商品 关系
export function relation(params) {
  return services({
    method: "GET",
    url: "/goods/purchase/relation",
    params: params,
  });
}
// 通过商品采购关系查询已关联sku信息
export function ShangRelation(params) {
  return services({
    method: "GET",
    url: `/goods/sku/purchase/relation/${params.relationTableId}`,
    params: params,
  });
}

// 更新销售商品和采购商品关系

export function update(params) {
  return services({
    method: "POST",
    url: "/goods/purchase/update",
    data: params,
  });
}

// 获取采购订单退货理由
export function refundReaso(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/reason",
    data: params,
  });
}
// 创建采购订单退货

export function refundCreate(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/create",
    data: params,
  });
}

// 预览订单
export function preview(params) {
  return services({
    method: "POST",
    url: "/purchase/order/preview",
    data: params,
  });
}

// 自定义下单
export function fastCreate(params) {
  return services({
    method: "POST",
    url: "/purchase/order/custom/place",
    data: params,
  });
}
// 自定义预览订单预览
export function customPlacePreview(params) {
  return services({
    method: "POST",
    url: "/purchase/order/custom/place/preview",
    data: params,
  });
}
/** 查询采购-销售 SKU 映射列表。必填：shopNumber、salesPlatformGoodsId、salesSkuId（GET 查询参数） */
export function listSalesSkuMapping(params) {
  return services({
    method: "GET",
    url: "/purchase/salesSkuMapping/list",
    params: params,
  });
}
// 切换自动采购启用状态
export function toggleAutoPurchaseEnable(params) {
  return services({
    method: "PUT",
    url: `/purchase/salesSkuMapping/toggleAutoPurchaseEnable/${params.tableId}`,
    params: {
      autoPurchaseEnable: params.autoPurchaseEnable,
    },
  });
}
// 删除sku的绑定关系
export function deleteSalesSkusMapping(params) {
  return services({
    method: "DELETE",
    url: `/purchase/salesSkuMapping/${params.tableId}`,
  });
}
// 删除商品的绑定关系
export function deleteSalesGoodsMapping(params) {
  return services({
    method: "DELETE",
    url: `/purchase/salesGoodsMapping/${params.tableId}`,
  });
}

// 查询采购销售商品映射列表
export function listSalesGoodsMapping(params) {
  return services({
    method: "GET",
    url: "/purchase/salesGoodsMapping/list",
    params: params,
  });
}
// 新增采购销售商品映射
export function createSalesGoodsMapping(params) {
  return services({
    method: "POST",
    url: "/purchase/salesGoodsMapping",
    data: params,
  });
}

// 详情
export function detail(params) {
  return services({
    method: "GET",
    url: "/purchase/order/platform/detail",
    params: params,
  });
}

// 获取 oaid 签名
// 获取 签名解密参数
export function getOaidSign(data) {
  return services.request({
    method: "POST",
    url: "/order/sales/getOaidSign",
    data: data,
  });
}

//解密

export function getDecryptionParameters(data) {
  return services.request({
    method: "POST",
    url: "/order/sales/getDecryptionParameters",
    data: data,
  });
}
// 备注
export function remark(data) {
  return services.request({
    method: "POST",
    url: "/order/sales/memo/update",
    data: data,
  });
}
//删除采购订单
export function deletePurchaseOrder(params) {
  return services({
    method: "DELETE",
    url: "/purchase/order",
    params: params,
  });
}

// 新增采购销售映射
export function createSalesSkuMapping(params) {
  return services({
    method: "POST",
    url: "purchase/salesSkuMapping",
    data: params,
  });
}
// 根据销售订单ID查询采购订单列表
export function listPurchaseOrderBySalesOrderTableId(params) {
  return services({
    method: "GET",
    url: "/purchase/order/queryBySalesOrderId",
    params: params,
  });
}
// 查询物流公司列表
export function companies(params) {
  return services({
    method: "GET",
    url: "/logistics/sales/companies",
    params: params,
  });
}
// 发货/logistics/sales/send
export function companiesSend(params) {
  return services({
    method: "POST",
    url: "/logistics/sales/send",
    data: params,
  });
}
// 全量解析
export function companiesUpdate(params) {
  return services({
    method: "POST",
    url: "/purchase/product/sync",
    data: params,
  });
}
// 修改采购商品映射备注

export function goodsRemark(params) {
  return services({
    method: "POST",
    url: "/purchase/salesGoodsMapping/remark",
    data: params,
  });
}

// 获取采购订单详情（先查库，库无则从1688同步后返回）
export function platformDetail(params) {
  return services({
    method: "GET",
    url: "/purchase/order/detail",
    params: params,
  });
}
// 补充采购记录
export function bindSales(params) {
  return services({
    method: "POST",
    url: "/purchase/order/bindSales",
    data: params,
  });
}

// 物流轨迹

export function trace(params) {
  return services({
    method: "POST",
    url: "/logistics/sales/trace",
    data: params,
  });
}

// 退货物流轨迹
export function returnTrace(params) {
  return services({
    method: "POST",
    url: "/logistics/sales/trace",
    data: params,
  });
}
// 取消订单

export function cancel(params) {
  return services({
    method: "POST",
    url: "/purchase/order/cancel",
    params: params,
  });
}
//  隐藏订单
export function hide(params) {
  return services({
    method: "POST",
    url: "/order/sales/hidden",
    data: params,
  });
}
// 协商历史
export function negotiationHistory(params) {
  return services({
    method: "GET",
    url: `/order/sales/refund/messages/${params.tableId}`,
  });
}
//拦截
export function intercept(params) {
  return services({
    method: "POST",
    url: "/order/sales/refund/intercept",
    data: params,
  });
}

// 同意退款
export function agreeRefund(params) {
  return services({
    method: "POST",
    url: "/order/sales/refund/agree",
    data: params,
  });
}
// 拒绝退款
export function rejectRefund(params) {
  return services({
    method: "POST",
    url: "/order/sales/refund/refuse",
    data: params,
  });
}
//获取拒绝退款原因列表
export function rejectRefundReasonList(params) {
  return services({
    method: "GET",
    url: `/order/sales/refund/refuseReasons/${params.tableId}`,
  });
}

// 同意退货
export function agreeReturn(params) {
  return services({
    method: "POST",
    url: "/order/sales/refund/agreeReturnGoods",
    data: params,
  });
}
// 获取协商退货退款渲染数据
export function negotiationReturnRefundRender(params) {
  return services({
    method: "GET",
    url: `/order/sales/refund/negotiateReturn/${params.tableId}`,
  });
}
// 发起协商退货退款（taobao.refund.negotiatereturn 提交）
export function negotiationReturnRefund(params) {
  return services({
    method: "POST",
    url: "/order/sales/refund/negotiateReturn",
    data: params,
  });
}
// 判断是否可发起协商
export function isNegotiateReturn(params) {
  return services({
    method: "GET",
    url: `/order/sales/refund/canNegotiate/${params.tableId}`,
  });
}
// 售后详情
export function afterSaleDetail(params) {
  return services({
    method: "GET",
    url: `/purchase/order/detail/${params.purchaseOrderTableId}`,
  });
}
// 采购退货退款页面渲染
export function returnRefundRender(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/render",
    data: params,
  });
}
// 创建采购订单退款（1688采购）
export function createReturn(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/create",
    data: params,
  });
}

// 创建采购订单退货退款（1688采购）
export function createReturnRefund(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/returnGoods",
    data: params,
  });
}
// 物流公司标识
export function logisticsCompany(params) {
  return services({
    method: "GET",
    url: "/logistics/purchase/companies",
    params: params,
  });
}

// 上传退款退货凭证图片
export function uploadReturnRefundImage(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/uploadRefundVoucher",
    data: params,
  });
}
// 根据退款单 tableId 查询退款详情
export function refundDetail(params) {
  return services({
    method: "GET",
    url: `/purchase/refund/detail/${params.tableId}`,
  });
}

//修改
export function updateRefund(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/modify",
    data: params,
  });
}
// 取消退款申请
export function cancelRefund(params) {
  return services({
    method: "POST",
    url: "/purchase/refund/cancel",
    data: params,
  });
}
// 查询用户绑定店铺的授权过期提醒（按优先级排序）
export function authExpireReminder(params) {
  return services({
    method: "GET",
    url: "/shop/auth/expiration",
    params: params,
  });
}